import { ref } from 'vue';

const useCurrencies = () => {
	const fiatCurrency = ref({
		nameId: 'EUR',
		name: 'EURO',
		prefix: '€',
		suffix: 'EUR',
	});

	return {
		fiatCurrency,
	};
};

export default useCurrencies;
